import * as React from 'react';
import {
    Create,
    Edit,
    EditButton,
    FileField,
    FileInput,
    List,
    required,
    SimpleForm,
    TextField,
    TextInput,
    useRecordContext
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';

const userFilters = [<TextInput source="all" label="Rechercher" alwaysOn />];

const PreviewMedia = ({ record = null, source, title }: any) => {
    if (typeof record == 'string') {
        record = {
            [source]: record + `?=${Math.random()}`,
        };
    }

    if (record && record.rawFile) title = record.rawFile.name;

    return <FileField record={record} source={source} title={title} target="_blank" />;
};

const MediaInput = (props) => {
    const record = useRecordContext(props);

    const title = record.originalFilename;

    return (
        <FileInput source={props.source} label="Média" validate={required()}>
            <PreviewMedia source="src" title={title} />
        </FileInput>
    );
};

export const MediaList = (props) => (
    <List {...props} filters={userFilters} bulkActionButtons={false} perPage={50} pagination={<AdminPagination />} exporter={false}>
        <AdminSelectableDatagrid>
            <TextField source="originalFilename" label="Nom du fichier original" />
            <EditButton />
            <HumanDeleteButton fields={["originalFilename"]} fallback="ce média" />
        </AdminSelectableDatagrid>
    </List>
);

export const MediaEdit = (props) => (
    <Edit {...props} mutationMode="optimistic" title={<HumanRecordTitle fields={["originalFilename"]} fallback="Média" />}>
        <SimpleForm redirect="list">
            <MediaInput source="mediaURL" />
        </SimpleForm>
    </Edit>
);

export const MediaCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <FileInput source="mediaURL" label="Média" validate={required()}>
                {/* <FileField source="src" title="title" /> */}
                <PreviewMedia source="src" />
            </FileInput>
        </SimpleForm>
    </Create>
);
